import * as types from "../types/dispactherNote.types";
import { 
  getOrderDispactherNoteList,
  getOrderDispactherNoteSingle,
  deleteOrderDispactherNote,
  postOrderDispactherNote,
  patchOrderDispactherNote
} from "../../services/dispactherNote.service";
import { validationErrors } from "../../utils/Helpers";


export const dispactherNoteListAction = () => {
  return async (dispatch, getState) => {
    try {
      await getOrderDispactherNoteList(getState().authReducer.token, getState().authReducer.user.id)
      .then((res) => {
        if (res.data.code === 200) {
          dispatch({
            type: types.SET_DISPACTHER_NOTES_LIST_DATA,
            payload: res.data.data,
          });
        }
      })
      ;
    } catch (e) { validationErrors(e) }
  };
};

export const dispactherNoteSingleAction = (id) => {
  return async (dispatch, getState) => {
    try {
      return getOrderDispactherNoteSingle(getState().authReducer.token, getState().authReducer.user.id, id);
    } catch (e) { validationErrors(e) }
  };
};

export const dispactherNoteDeleteAction = (data) => {
  return async (dispatch, getState) => {
    try {
      return deleteOrderDispactherNote(getState().authReducer.token, getState().authReducer.user.id, data);
    } catch (e) {
      validationErrors(e);
    }
  };
};

export const dispactherNotePostAction = (data, id) => {
  return async (dispatch, getState) => {
    try {
      return postOrderDispactherNote(getState().authReducer.token, getState().authReducer.user.id, data, id);
    } catch (e) {
      validationErrors(e);
    }
  };
};

export const dispactherNotePatchAction = (data, id) => {
  return async (dispatch, getState) => {
    try {
      return patchOrderDispactherNote(getState().authReducer.token, getState().authReducer.user.id, data, id);
    } catch (e) {
      validationErrors(e);
    }
  };
};